import styled, { css } from 'styled-components';
import { rem } from 'polished';

import Icon from '../../core/Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

export const Title = styled.h1`
  color: Crimson;
  font-size: ${props => props.theme.fontSize.large};
  line-height: 22px;
  text-align: center;
  margin: 0 0 5px 0;
  padding: 0;
`;

export const Button = styled.button`
  border: 0;
  background: transparent;
  font-weight: bold;
  color: Crimson;
  text-decoration: underline;
  outline: 0;
  margin-bottom: 5px;
`;

export const IconWarning = styled(Icon)`
  width: 150px;
  height: 150px;
  display: inline-block;
  opacity: 0.03;
  position: absolute;
  right: 10px;
  z-index: 0;
  top: 50%;
  transform: translate(0, -50%);
`;

export const Subtitle = styled.h2`
  color: Black;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  margin: 0 0 10px 0;
  padding: 0;
`;

export const Content = styled.p`
  color: Crimson;
  font-size: 12px;
  line-height: 14px;
  font-weight: light;
  text-align: left;
  padding: 10px;
`;

export const Container = styled.div`
  background: GhostWhite;
  padding: 0;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  max-height: 0;
  transition: all 500ms ease;

  ${props =>
    props.active &&
    css`
      max-height: 500px;
    `};
`;

export const StyledBoxMessage = styled.div`
  text-align: center;
  background-color: ${props => props.theme.colors.grayLightest};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${mediaqueries.greaterThan('desktop')`
    min-height: ${rem('200px')};
    padding-left: ${rem('74px')};
    padding-right: ${rem('74px')};
  `};
  position: relative;
  ${mediaqueries.lessThan('mobile')`
    min-height:${rem('271px')};
  `};
`;

export const StyledMessageTitle = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  text-transform: uppercase;
  margin-bottom: 0;
  span {
    font-family: ${props => props.theme.fonts.medium};
    display: block;
    line-height: ${rem('16px')};
    ${mediaqueries.greaterThan('desktop')`
        display:inline;
    `};
  }
`;

export const StyledIconRazor = styled(Icon)`
  width: ${rem('74px')};
  right: ${rem('20px')};
  position: absolute;
  bottom: 0;
  ${mediaqueries.lessThan('mobile')`
    right: ${rem('30px')};
    width: ${rem('47px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    right: ${rem('40px')};
    width: ${rem('51px')};
  `};
`;
